import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  checkPermision,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
} from "../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { FormHelperText } from "@material-ui/core";
import { LocationMasterTable } from "./LocationMasterTable";
import {
  addLocationMaster,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectLocationMaster,
  fetchLocationMaster,
  fetchCountryAll,
  selectCountryAll,
  selectPermissionLocationMaster,
  selectPageNoLocation,
  selectPageSizeLocation,
  selectTotalRecordLocation,
} from "./locationSlice";
import { Autocomplete } from "@material-ui/lab";
import { selectPermissionCategory } from "../motorPool/motorPoolSlice";
import {
  fetchParameter,
  selectParameter,
} from "../businessParameter/businessParameterSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const LocationMasterTab = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectLocationMaster);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNoLocation);
  const pageSize = useSelector(selectPageSizeLocation);
  const totalRecord = useSelector(selectTotalRecordLocation);
  const paginationSet = useSelector(selectPagination);
  const dataCountry = useSelector(selectCountryAll);
  const dataLocation = useSelector(selectParameter);
  const permission = useSelector(selectPermissionLocationMaster);
  const forceUpdate = useForceUpdate();

  // Filter
  const [value, setValue] = useState(0);
  const [force, setForce] = useState(false);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchLocationMaster({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchCountryAll({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter({
          paramgroup_code: "LOCATION_TYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setForce(false);
    }
  }, [force]);

  const handleSearch = async () => {
    let params = {};
    fields.forEach((item) => {
      params[item.params] = item.value;
    });
    params.is_enable = value === 0 ? "Y" : "N";
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchLocationMaster(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};
      fields.forEach((item) => {
        params[item.params] = item.value;
      });

      params.is_enable = value === 0 ? "Y" : "N";
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchLocationMaster(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  // new
  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };
  // paket filter

  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",

      value: "locationmaster_code",
      label: "Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "locationmaster_name",
      label: "Name",
      show: "Y",
      editor: "text",
    },
  ]);

  // paket filter

  const [btnHide, setBtnHide] = useState(false);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      values[i].remove = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      const filteredShow = result.filter((item) => item.show === "Y");
      if (filteredShow.length <= 1) {
        setBtnHide(true);
      } else {
        setBtnHide(false);
      }

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });

    setTypeOptions(result);

    const filteredShow = result.filter((item) => item.show === "Y");
    if (filteredShow.length >= 1) {
      setBtnHide(false);
    } else {
      setBtnHide(true);
    }

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    setFields(values);
  };

  // paket filter bawah
  // Func Create
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormValues({
      locationmaster_code: {
        value: "",
        error: false,
        required: "Y",
      },
      locationmaster_name: {
        value: "",
        error: false,
        required: "Y",
      },
      locationmaster_country: {
        value: "",
        error: false,
        required: "Y",
      },
      locationmaster_type: {
        value: "",
        error: false,
        required: "Y",
      },
      locationmaster_latitude: {
        value: "",
        error: false,
        required: "N",
      },
      locationmaster_longitude: {
        value: "",
        error: false,
        required: "N",
      },
      locationmaster_city: {
        value: "",
        error: false,
        required: "N",
      },
      locationmaster_uncode: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const [formValues, setFormValues] = useState({
    locationmaster_code: {
      value: "",
      error: false,
      required: "Y",
    },
    locationmaster_name: {
      value: "",
      error: false,
      required: "Y",
    },
    locationmaster_country: {
      value: "",
      error: false,
      required: "Y",
    },
    locationmaster_country_name: {
      value: "",
      error: false,
      required: "Y",
    },
    locationmaster_type: {
      value: "",
      error: false,
      required: "Y",
    },
    locationmaster_latitude: {
      value: "",
      error: false,
      required: "N",
    },
    locationmaster_longitude: {
      value: "",
      error: false,
      required: "N",
    },
    locationmaster_city: {
      value: "",
      error: false,
      required: "N",
    },
    locationmaster_uncode: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      locationmaster_code: formValues.locationmaster_code.value,
      locationmaster_name: formValues.locationmaster_name.value,
      locationmaster_country: formValues.locationmaster_country.value,
      locationmaster_type: formValues.locationmaster_type.value,
      locationmaster_latitude: formValues.locationmaster_latitude.value,
      locationmaster_longitude: formValues.locationmaster_longitude.value,
      locationmaster_city: formValues.locationmaster_city.value,
      locationmaster_uncode: formValues.locationmaster_uncode.value,
    };

    try {
      const response = await dispatch(addLocationMaster(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await handleClose();
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChangeCountry = (e, params) => {
    const value = params.value;
    const name = params.label;
    setFormValues({
      ...formValues,
      ["locationmaster_country"]: {
        ...formValues["locationmaster_country"],
        value,
      },
      ["locationmaster_country_name"]: {
        ...formValues["locationmaster_country_name"],
        value: name,
      },
    });
  };

  const handleChangeType = (e, params) => {
    const value = params.value;
    const name = params.label;
    setFormValues({
      ...formValues,
      ["locationmaster_type"]: {
        ...formValues["locationmaster_type"],
        value,
      },
    });
  };

  const countryOptions = dataCountry.map((e) => {
    return {
      value: e.country_id,
      label: e.country_name,
    };
  });

  const locationOptions = dataLocation.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });


  const index = countryOptions.findIndex(
    (obj) => obj.value === formValues.locationmaster_country.value
  );

  const indexLocation = locationOptions.findIndex(
    (obj) => obj.value === formValues.locationmaster_type.value
  );

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            {checkPermision(permission, "CREATE") && (
              <Button
                className="btn btn-primary my-btn-primary-dark text-bold mb-5"
                onClick={handleShow}
              >
                New Location Master
              </Button>
            )}
            {fields.map((field, idx) => {
              return (
                <div key={`${field}-${idx}`}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={1}>
                      {idx === 0 && <b>Search By</b>}
                    </Form.Label>

                    <Col sm={3}>
                      {fields[idx].add === "N" && (
                        <Select
                          // isClearable={true}
                          options={data_filter}
                          value={getValueType(field.params, typeOptions)}
                          placeholder="Select Field"
                          // onChange={handleTypeChange}
                          onChange={(e) => handleTypeChange(idx, e)}
                        />
                      )}
                      {fields[idx].add === "Y" && (
                        <Form.Control
                          type="text"
                          value={fields[idx].label}
                          disabled
                        />
                      )}
                    </Col>
                    <Col sm={3}>
                      {field.editor === "text" && (
                        <Form.Control
                          type="text"
                          placeholder="Enter text"
                          value={field.value || ""}
                          onChange={(e) => handleRemarkChange(idx, e)}
                        />
                      )}
                    </Col>
                    <Col sm={3} className=" m-0 p-0">
                      {fields[idx].remove === "Y" && (
                        <div
                          className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                          onClick={() => handleRemove(idx)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-light">
                            <SVG
                              src={toAbsoluteUrl("/media/svg/icons/New/X.svg")}
                            />
                          </span>
                        </div>
                      )}

                      {btnHide === false && fields.length - 1 === idx && (
                        <Button
                          className="mr-3"
                          variant="outline-primary"
                          onClick={(e) => handleAdd(idx, e)}
                        >
                          Add
                        </Button>
                      )}

                      {fields.length - 1 === idx && (
                        <Button
                          className="mr-3"
                          variant="primary"
                          onClick={handleSearch}
                        >
                          Search
                        </Button>
                      )}
                    </Col>
                  </Form.Group>
                </div>
              );
            })}

            <>
              <Tabs
                value={value}
                onChange={handleChangeTab}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="Enabled" />
                <Tab label="Disabled" />
              </Tabs>
              {value === 0 && (
                <LocationMasterTable
                   data={data === null ? [] : data}
                  page={pageNo}
                  sizePerPage={pageSize}
                  totalSize={totalRecord}
                  onTableChange={handleTableChange}
                  loading={loading}
                  handleSearch={handleSearch}
                />
              )}
              {value === 1 && (
                <LocationMasterTable
                   data={data === null ? [] : data}
                  page={pageNo}
                  sizePerPage={pageSize}
                  totalSize={totalRecord}
                  onTableChange={handleTableChange}
                  loading={loading}
                  handleSearch={handleSearch}
                />
              )}
            </>
          </CardBody>
        </Card>

        {/* Modal Create */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              New Location Master
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    {" "}
                    <RedditTextField
                      required
                      label="Code"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="locationmaster_code"
                      value={formValues.locationmaster_code.value}
                      onChange={handleChange}
                      error={formValues.locationmaster_code.error}
                      helperText={
                        formValues.locationmaster_code.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                    <RedditTextField
                      required
                      label="Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="locationmaster_name"
                      value={formValues.locationmaster_name.value}
                      onChange={handleChange}
                      error={formValues.locationmaster_name.error}
                      helperText={
                        formValues.locationmaster_name.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                    <Autocomplete
                      disablePortal
                      name="locationmaster_type"
                      options={locationOptions}
                      getOptionLabel={(option) => option.label.toString()}
                      disableClearable={true}
                      onChange={handleChangeType}
                      value={locationOptions[indexLocation]}
                      renderInput={(params) => (
                        <RedditTextField
                          required
                          className={classes.margin}
                          {...params}
                          label="Type"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="locationmaster_type"
                          error={formValues.locationmaster_type.error}
                          helperText={
                            formValues.locationmaster_type.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      )}
                    />
                    {/* <RedditTextField
                      label="Select"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="locationmaster_type"
                      value={formValues.locationmaster_type.value}
                      onChange={handleChange}
                    /> */}
                    <RedditTextField
                      label="City"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="locationmaster_city"
                      value={formValues.locationmaster_city.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Autocomplete
                      disablePortal
                      name="locationmaster_country"
                      options={countryOptions}
                      getOptionLabel={(option) => option.label.toString()}
                      disableClearable={true}
                      onChange={handleChangeCountry}
                      value={countryOptions[index]}
                      renderInput={(params) => (
                        <RedditTextField
                          required
                          className={classes.margin}
                          {...params}
                          label="Country"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          placeholder="Select Country"
                          name="locationmaster_country"
                          error={formValues.locationmaster_country.error}
                          helperText={
                            formValues.locationmaster_country.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      )}
                    />
                    <RedditTextField
                      label="Latitude"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="locationmaster_latitude"
                      value={formValues.locationmaster_latitude.value}
                      onChange={handleChange}
                    />
                    <RedditTextField
                      label="Longitude"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="locationmaster_longitude"
                      value={formValues.locationmaster_longitude.value}
                      onChange={handleChange}
                    />
                    <RedditTextField
                      label="UN Code"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="locationmaster_uncode"
                      value={formValues.locationmaster_uncode.value}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
              </div>
            </ThemeProvider>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
